import { ApiCollection, Model } from '@kaiser-software/chassis-core';
import { KpiModel } from './kpi.model';

export class KpiSetModel extends Model {

    public createdAt: string;

    public updatedAt: string;

    // public kpis: Array<any> = [];

    public kpis(): ApiCollection {
        return this.hasMany(KpiModel, 'kpis', { kpiSet: this.id });
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/kpis/models/kpi-set.model.ts